import SelectRegionsAndStoresZone from '../../../../components/Slots/TemplateZoneMatching/SelectRegionsStoresZone';
import React, { Suspense, useEffect, useState } from 'react';
import {
  Button,
  Col,
  ConfigProvider,
  notification,
  Popconfirm,
  Row,
  Switch,
  Table,
  Tag,
  Tooltip,
} from 'antd';
import {
  CalendarOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PlusOutlined,
  RetweetOutlined,
  UnorderedListOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import userHaveRolePermission from '../../../../helpers/userHaveRolePermission';
import { PAGE_URLS } from '../../../../helpers/endpoints';
import trTR from 'antd/es/locale/tr_TR';
import moment from 'moment';
import CalendarComponent from '../../../../components/Slots/CalendarComponent';
import {
  changeStatusZoneSlotTemplates,
  deleteZoneSlotTemplates,
  getZoneSlotTemplates,
} from '../../../../store/requests/slot';
import ImportZoneTemplate from 'components/ImportExcel/ImportZoneTemplate';
import { CSVLink } from 'react-csv';
import { STATUS } from '../../../../helpers/constants';

const Add = React.lazy(() => import('./Add'));

const TemplateZoneMatching = ({ route }) => {
  const history = useHistory();
  const { isViewEnabled, isCrudEnabled } = userHaveRolePermission(route?.name);
  if (!isViewEnabled) {
    history.push(`${PAGE_URLS.AUTH}${PAGE_URLS.CONTROL}`);
  }
  const { t } = useTranslation();
  const [slotTemplatesData, setSlotTemplatesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectListOrCalendar, setSelectListOrCalendar] = useState(false);
  const [filterTemplateZonePayload, setFilterTemplateZonePayload] =
    useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(null);
  const [disabledStatusButton, setDisabledStatusButton] = useState(true);
  const [changeStatusLoading, setChangeStatusLoading] = useState(false);
  const [deleteSlotTemplatesLoading, setDeleteSlotTemplatesLoading] =
    useState(false);

  useEffect(() => {
    if (filterTemplateZonePayload) {
      fetchData();
    }
  }, [filterTemplateZonePayload]);

  const fetchData = () => {
    if (filterTemplateZonePayload) {
      setLoading(true);
      setSelectListOrCalendar(false);
      getZoneSlotTemplates(filterTemplateZonePayload)
        .then((templateZone) => {
          setSlotTemplatesData(templateZone);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const columns = [
    {
      dataIndex: 'zone',
      title: t('regions'),
      showSorterTooltip: false,
      sorter: (a, b) => {
        const regionA = a.zone?.store?.region?.name;
        const regionB = b.zone.store?.region?.name;
        return regionA.localeCompare(regionB);
      },
      render: (dataItem) => dataItem?.store?.region?.name,
    },
    {
      dataIndex: 'zone',
      title: t('stores'),
      sorter: (a, b) => {
        const storeA = a.zone?.store?.name;
        const storeB = b.zone?.store?.name;
        return storeA.localeCompare(storeB);
      },
      showSorterTooltip: false,
      render: (dataItem) =>
        `${dataItem?.store?.code} - ${dataItem?.store?.name}`,
    },
    {
      dataIndex: 'zone',
      title: t('zone'),
      sorter: (a, b) => {
        const zoneA = a.zone?.name;
        const zoneB = b.zone?.name;
        return zoneA.localeCompare(zoneB);
      },
      showSorterTooltip: false,
      render: (dataItem) => `${dataItem?.code} - ${dataItem?.name}`,
    },
    {
      dataIndex: 'slotTemplate',
      title: t('templateName'),
      sorter: (a, b) => a.slotTemplate.name.localeCompare(b.slotTemplate.name),
      showSorterTooltip: false,
      render: (dataItem) => dataItem?.name,
    },
    {
      dataIndex: 'startDate',
      title: t('placeholder.startDate'),
      showSorterTooltip: false,
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      render: (dataItem) => moment(dataItem).format('DD-MM-YYYY'),
    },
    {
      dataIndex: 'endDate',
      title: t('placeholder.endDate'),
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      showSorterTooltip: false,
      render: (dataItem) => moment(dataItem).format('DD-MM-YYYY'),
    },
    {
      dataIndex: 'active',
      title: t('active'),
      sorter: (a, b) => a.active - b.active,
      showSorterTooltip: false,
      render: (dataItem) =>
        dataItem ? (
          <Tag color={'green'}>{t('active')}</Tag>
        ) : (
          <Tag color={'red'}>{t('passive')}</Tag>
        ),
    },
    /*{
            width: 50,
            render: (dataItem) => (isCrudEnabled &&
                <Dropdown
                    menu={{
                        items: [
                            {
                                label: t('edit'),
                                icon: <EditOutlined />,
                                onClick: () => {
                                    setIsEditModalOpen(true);
                                }
                            },
                        ]
                    }}
                    placement="bottomRight"
                    arrow
                    trigger={['click']}
                >
                    <Button shape="circle" icon={<MoreOutlined />}></Button>
                </Dropdown>
            )
        },*/
  ];

  const actions = [
    {
      isCrudEnabled,
      type: 'primary',
      title: t('add'),
      icon: <PlusOutlined />,
      onClick: () => {
        setSelectListOrCalendar(false);
        setIsAddModalOpen(true);
      },
      disablePopConfirm: true,
      showActionButton: true,
    },
    {
      isCrudEnabled,
      title: t('slotManagement.changeStatus'),
      icon: <RetweetOutlined />,
      disabled: selectedRows.length <= 0 || disabledStatusButton,
      loading: changeStatusLoading,
      disablePopConfirm: selectedRows.length <= 0 || disabledStatusButton,
      popConfirmTitle: t('slotManagement.changeStatusConfirmMessage'),
      click: () => changeStatusSelectedZoneSlotTemplate(),
      showActionButton: !selectListOrCalendar,
    },
    {
      isCrudEnabled: true,
      type: '',
      title: t('download'),
      customContent: (
        <CSVLink
          filename={'ZoneSlotEslestirme'}
          data={[
            columns.map((item) => item.title),
            ...slotTemplatesData?.map((item) => [
              item?.zone?.store.region?.name,
              `${item?.zone?.store?.code} - ${item?.zone?.store?.name}`,
              `${item?.zone?.code} - ${item?.zone?.name}`,
              item.slotTemplate.name,
              moment(item?.startDate)?.format('DD/MM/YYYY'),
              moment(item?.endDate)?.format('DD/MM/YYYY'),
              t(item.active),
            ]),
          ]}
          disabled={slotTemplatesData.length <= 0}
        >
          <Button
            style={{ marginRight: '3px' }}
            shape="round"
            icon={<DownloadOutlined />}
            disabled={slotTemplatesData.length <= 0}
          ></Button>
        </CSVLink>
      ),
      onClick: () => {},
      disabled: slotTemplatesData.length <= 0,
      disablePopConfirm: true,
      showActionButton: true,
    },
    {
      isCrudEnabled,
      type: 'primary',
      title: t('remove'),
      danger: true,
      icon: <DeleteOutlined />,
      disabled: selectedRows.length <= 0,
      loading: deleteSlotTemplatesLoading,
      disablePopConfirm: selectedRows.length <= 0,
      popConfirmTitle: t('slotManagement.deleteConfirmMessage'),
      click: () => deleteSelectedZoneSlotTemplates(),
      showActionButton: !selectListOrCalendar,
    },
    {
      isCrudEnabled,
      type: '',
      title: t('import'),
      icon: <UploadOutlined />,
      onClick: () => setIsImportModalOpen(true),
      disabled: false,
      disablePopConfirm: true,
      showActionButton: true,
    },
  ];

  const renderActionButton = (item, idx) => {
    const renderContent = () => (
      <Button
        type={item.type}
        shape="round"
        danger={item.danger}
        icon={item.icon}
        onClick={item.onClick}
        disabled={item.disabled}
        style={{ marginBottom: '10px', marginRight: '3px' }}
        loading={item.loading}
      />
    );

    return (
      <Tooltip title={item.title} key={idx}>
        {item.popConfirmTitle ? (
          <Popconfirm
            title={item.popConfirmTitle}
            onConfirm={item.click}
            okText={t('yes')}
            cancelText={t('no')}
            disabled={item.disabled}
            overlayStyle={{ width: 360 }}
          >
            {item.isCrudEnabled && (item.customContent ?? renderContent())}
          </Popconfirm>
        ) : (
          <>
            {item.isCrudEnabled && (item.customContent ?? renderContent())}
          </>
        )}
      </Tooltip>
    );
  };

  const renderActionButtons = () => {
    return actions.map((item, idx) => (
      item.showActionButton && renderActionButton(item, idx)
    ));
  };

  const changeStatusSelectedZoneSlotTemplate = () => {
    const payload = {
      ids: selectedRowKeys,
      active: !selectedRows[0].active,
    };
    setChangeStatusLoading(true);
    changeStatusZoneSlotTemplates(payload)
      .then(() => {
        notificationToaster(
          STATUS.SUCCESS,
          t('slotManagement.changeStatusSuccess'),
        );
        fetchData();
      })
      .finally(() => {
        setChangeStatusLoading(false);
        setSelectedRowKeys([]);
        setSelectedRows([]);
      });
  };

  const deleteSelectedZoneSlotTemplates = () => {
    if (selectedRows.some((item) => item.slotTemplate.defaultForAll)) {
      notificationToaster(
        STATUS.ERROR,
        t('slotManagement.masterTemplateCannotBeDeleted'),
      );
      return;
    }
    setDeleteSlotTemplatesLoading(true);
    deleteZoneSlotTemplates({ ids: selectedRowKeys })
      .then(() => {
        notificationToaster(
          STATUS.SUCCESS,
          t('slotManagement.deleteSuccessMessage'),
        );
        fetchData();
      })
      .finally(() => {
        setDeleteSlotTemplatesLoading(false);
        setSelectedRowKeys([]);
        setSelectedRows([]);
      });
  };

  useEffect(() => {
    if (selectedRows.length <= 0) {
      setDisabledStatusButton(true);
      return;
    }
    const activeStatus = selectedRows.map((item) => item.active);
    const allActiveStatus = activeStatus.every((item) => item === true);
    const allPassiveStatus = activeStatus.every((item) => item === false);
    setDisabledStatusButton(!(allActiveStatus || allPassiveStatus));
  }, [selectedRows]);

  const notificationToaster = (type, description) => {
    notification[type]({
      message: t('processCompleted'),
      description,
    });
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    selectedRows,
    onChange: onSelectChange,
  };

  return (
    <>
      <SelectRegionsAndStoresZone
        setSelectedRows={setSelectedRows}
        setSlotTemplatesData={setSlotTemplatesData}
        setSelectedRowKeys={setSelectedRowKeys}
        setFilterTemplateZonePayload={setFilterTemplateZonePayload}
        setSelectListOrCalendar={setSelectListOrCalendar}
        loading={loading}
      />

      <Row style={{ marginTop: '10px' }}>
        <Col span={24}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>{renderActionButtons()}</div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Switch
                defaultChecked={selectListOrCalendar}
                checked={selectListOrCalendar}
                disabled={slotTemplatesData.length <= 0}
                onChange={(checked) => setSelectListOrCalendar(checked)}
                checkedChildren={<CalendarOutlined />}
                unCheckedChildren={<UnorderedListOutlined />}
              />
              <span style={{ marginLeft: '5px' }}>{t('listOrCalender')}</span>
            </div>
          </div>
        </Col>
        <ConfigProvider locale={trTR}>
          {!selectListOrCalendar ? (
            <Table
              rowSelection={rowSelection}
              style={{ width: '100%' }}
              size="small"
              columns={columns}
              dataSource={slotTemplatesData}
              rowKey={(record) => record.id}
              scroll={{
                y: '70vh',
              }}
            />
          ) : (
            <CalendarComponent slotData={slotTemplatesData} />
          )}
        </ConfigProvider>
      </Row>
      <Suspense fallback={<></>}>
        {isAddModalOpen && (
          <Add
            selectedSlotsData={selectedRows[0] ? [selectedRows[0]] : []}
            setSelectedRowKeys={setSelectedRowKeys}
            setSelectedSlotsData={setSelectedRows}
            onCloseHandler={() => {
              setIsAddModalOpen(false);
            }}
            onSuccessCallback={() => {
              setIsAddModalOpen(false);
            }}
          />
        )}
        {isImportModalOpen && (
          <ImportZoneTemplate
            setSelectListOrCalendar={setSelectListOrCalendar}
            onCloseHandler={() => setIsImportModalOpen(false)}
            onSuccessCallback={fetchData}
          />
        )}
      </Suspense>
    </>
  );
};

export default TemplateZoneMatching;
